/**
 *
 * @class ProjectSummary
 *
 * property holder for project summaries.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin
 * @date      February 2024
 *
 */
import {DateTime} from "luxon";

export class ProjectSummary {

  public oid: number         = 0;
  public guid: string        = '';
  public name: string        = '';
  public key: string         = '';
  public owner: string       = '';
  public type: string        = '';
  public description: string = '';
  public tags: string[]      = [];
  public data: string        = '';
  public created: DateTime;
  public modified: DateTime;


  /** standard constructor */
  public constructor(init?: Partial<ProjectSummary>) {

    /* if they gave us creation time (UTC), convert to local time */

    if (typeof init['created'] != 'undefined') {

      init['created'] = DateTime.fromISO((init as any)['created'].replace(' ', 'T'), {zone: 'UTC'}).toLocal();
    }

    /* if they gave us modification time (UTC), convert to local time */

    if (typeof init['modified'] != 'undefined') {

      init['modified'] = DateTime.fromISO((init as any)['modified'].replace(' ', 'T'), {zone: 'UTC'}).toLocal();
    }

    Object.assign(this, init);
  }
}
